import * as React from "react";
import { useCallback, useMemo } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import callLeft from "../assets/img/EmergencyServices/callLeft.svg";
import callRight from "../assets/img/EmergencyServices/callRight.svg";
import { makeStyles } from "@mui/styles";
import { Typography } from "@mui/material";
import clsx from "clsx";
import { useSelector } from "react-redux";
import { formatPhoneForTel, getOrgContactList, getTranslation } from "../helpers/utils";

const useStyles = makeStyles((theme) => ({
  bgcolor: {
    background: "#FFFFFF",
  },
  textColor: {
    color: theme.palette.emergency.main,
  },
  sectionbg: {
    background: theme.palette.emergency.light,
  },
  medWidth: {
    [theme.breakpoints.up("md")]: {
      width: "450px !important",
    },
  },
}));

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "#F6F1F4",
  p: 4,
  width: "100%",
  maxWidth: "min(450px, calc(100vw - 32px))",
  maxHeight: "min(90dvh, 720px)",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  boxSizing: "border-box",
};

export default function ModalAbout({ open, handleClose, item }) {
  const classes = useStyles();
  const { isEnglish, langId } = useSelector((state) => state.language);
  const [description, setDescription] = React.useState();
  const [hours, setHours] = React.useState();

  // Helper to safely extract text from Translation objects (memoized for useEffect deps)
  const getTextFromTranslation = useCallback((translation) => {
    if (!translation) return '';
    if (typeof translation === 'string') return translation;
    if (Array.isArray(translation)) {
      const result = getTranslation(translation, langId);
      if (result && typeof result === 'string') return result;
      if (translation.length > 0 && translation[0]?.text && typeof translation[0].text === 'string') {
        return translation[0].text;
      }
      return '';
    }
    if (typeof translation === 'object' && translation.text) {
      return typeof translation.text === 'string' ? translation.text : '';
    }
    return '';
  }, [langId]);

  React.useEffect(() => {
    const createDes = (str) => {
      if (!str) return;
      
      // Extract text if it's a Translation object
      const textStr = typeof str === 'string' ? str : getTextFromTranslation(str);
      if (!textStr || typeof textStr !== "string") return;

      let data = textStr.split(":");
      setDescription(data[0]);
      setHours(data[1]);
    };
    createDes(item?.description);
  }, [item, langId, getTextFromTranslation]);

  const contactList = useMemo(
    () => getOrgContactList(item?.contact, langId),
    [item?.contact, langId]
  );

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          className={`border-2 border-red-100 rounded-2xl w-72 focus:outline-none ${classes.medWidth}`}
          sx={style}
        >
          <h6
            className={`text-center mb-4 flex-shrink-0 ${classes.textColor} font-bold`}
          >
            {getTextFromTranslation(item?.title)}
          </h6>
          <Box
            sx={{
              overflowY: "auto",
              flex: "1 1 auto",
              minHeight: 0,
              WebkitOverflowScrolling: "touch",
              pr: 0.5,
            }}
          >
            <div className={clsx(" p-5 rounded-3xl", classes.sectionbg)}>
              <Typography
                className={`mt-3 block ${isEnglish ? "text-left" : "text-right"}`}
                variant="p"
                style={{ whiteSpace: "pre-wrap" }}
                color={"white"}
              >
                {description}
              </Typography>
              <Typography
                className={`mt-3 block ${isEnglish ? "text-left" : "text-right"}`}
                variant="p"
                color={"white"}
              >
                {hours}
              </Typography>
            </div>
            {contactList.map((number, index) => {
              const tel = formatPhoneForTel(number);
              return (
                <a
                  key={`${number}-${index}`}
                  href={tel ? `tel:${tel}` : undefined}
                  className={clsx(
                    "flex p-5 mt-5 rounded-3xl items-center no-underline",
                    classes.sectionbg,
                    isEnglish ? "flex-row" : "flex-row-reverse",
                    tel ? "cursor-pointer" : "pointer-events-none"
                  )}
                >
                  <img
                    className="w-5 h-5"
                    src={isEnglish ? callLeft : callRight}
                    alt="call"
                  />
                  <Typography variant="p" color={"white"} className="mx-3">
                    {number}
                  </Typography>
                </a>
              );
            })}
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
